interface Props {
  eyebrow: string;
  title: string;
  highlight?: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, highlight, desc, align = "center" }: Props) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${alignCls} max-w-3xl mx-auto`}>
      <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
        <i className="ri-fire-fill text-primary-500 w-3 h-3 flex items-center justify-center"></i>
        {eyebrow}
      </span>
      <h2 className="mt-4 font-serif text-2xl md:text-4xl font-bold leading-snug text-foreground-950">
        {title}
        {highlight && <span className="text-primary-600"> {highlight}</span>}
      </h2>
      {desc && <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-600">{desc}</p>}
    </div>
  );
}